import type { Client, RequestContext } from "../client";
import type { LifecycleResource, GetLifecyclesV2Response } from "../resources";
import type { ProjectResource } from "../resources/projectResource";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";
export type LifecycleListArgs = ListArgs & {
    partialName?: string;
};
export class LifecycleRepository extends BasicRepository<LifecycleResource, LifecycleResource, LifecycleListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Lifecycles", client, requestContext);
    }
    preview(lifecycle: LifecycleResource): Promise<LifecycleResource> {
        return this.client.get(this.requestContext, lifecycle.Links["Preview"]);
    }
    previews(ids: string[]): Promise<LifecycleResource[]> {
        return this.client.get(this.requestContext, this.client.getLink("LifecyclePreviews"), { ids: ids.join(",") });
    }
    projects(lifecycle: LifecycleResource) {
        return this.client.get<ProjectResource[]>(this.requestContext, lifecycle.Links["Projects"]);
    }
    getV2(spaceId: string, skip: number, take: number, type?: string): Promise<GetLifecyclesV2Response> {
        return this.client.get<GetLifecyclesV2Response>(this.requestContext, "~/api/spaces/{spaceId}/lifecycles/v2{?skip,take,type}", { spaceId: spaceId, skip: skip, take: take, type: type });
    }
}
